import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latestComics = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 12);

  return (
    <section className="py-8 md:py-10 px-4 md:px-6 bg-background-100" aria-label="最新更新">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-xs text-foreground-500 mt-1">实时更新，精彩不容错过</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}